<template lang="pug">
modal-window.modal-study-result-image(:title='title', ref='modalWindow', :width='900', :height='600')
  .modal-study-result-image__inner
    .modal-study-result-image__inner__content
      image-base.modal-study-result-image__inner__content__image(:src='imageUrl')
</template>

<script lang="ts">
import { Component, Prop, Vue, Ref } from 'vue-property-decorator'
import ModalWindow from '@/components/molecules/manager/ModalWindow.vue'
import ImageBase from '@/components/atoms/ImageBase.vue'

@Component({
  components: {
    ModalWindow,
    ImageBase,
  },
})
export default class ModalStudyResultImage extends Vue {
  // モーダルタイトル
  @Prop()
  title!: string

  // 画像URL
  @Prop()
  imageUrl!: string

  // モーダルウィンドウRef
  @Ref()
  modalWindow!: ModalWindow

  public show() {
    this.modalWindow.show()
  }
}
</script>

<style lang="stylus" scoped>
.modal-study-result-image
  &__inner
    display flex
    height 513px
    width 860px
    flex-direction column
    justify-content center
    align-items center

    &__content
      display flex
      justify-content center
      align-items center
      overflow-y auto

      &__image
        width 100%
        height 100%
        object-fit contain
</style>
